export default {
  questionCol: {},
  typeCol: {
    width: 120,
  },
  mandatoryCol: {
    width: 100,
  },
  actionCol: {
    width: 120,
  },
  noQuestionsContainer: {
    textAlign: 'center',
  },
  noQuestions: {
    height: 150,
    fontSize: 180,
    color: 'lightgrey',
  },

};



// WEBPACK FOOTER //
// ./src/components/QuestionsTable/styles.js